import { GRANT_ACCESS } from "./types";

const grantAccess = (data) => ({
  type: GRANT_ACCESS,
  data,
});

export default grantAccess;
